module.exports = __webpack_public_path__ + "img/customer-icon-17.94f1c46a.png";